import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
	selector: 'app-receipt-modal',
	templateUrl: './receipt-modal.component.html',
	styleUrls: ['./receipt-modal.component.sass'],
})
export class ReceiptModalComponent {
	@Input() status: 'success' | 'error';
	@Input() modalMessage: string;
	constructor(private activeModal: BsModalRef) {}

	close() {
		this.activeModal.hide();
	}
}
